import { forwardRef } from 'react';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { cn } from '@/lib/cn';

export const DropdownMenu = RadixDropdown.Root;
export const DropdownMenuTrigger = RadixDropdown.Trigger;
export const DropdownMenuPortal = RadixDropdown.Portal;

export const DropdownMenuContent = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdown.Content>
>(function DropdownMenuContent({ className, sideOffset = 6, ...rest }, ref) {
  return (
    <DropdownMenuPortal>
      <RadixDropdown.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn('gs-popover z-50', className)}
        {...rest}
      />
    </DropdownMenuPortal>
  );
});

export const DropdownMenuItem = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdown.Item> & { danger?: boolean }
>(function DropdownMenuItem({ className, danger, ...rest }, ref) {
  return (
    <RadixDropdown.Item
      ref={ref}
      className={cn(
        'gs-popover__item',
        danger && 'gs-popover__item--danger',
        className,
      )}
      {...rest}
    />
  );
});

export const DropdownMenuSeparator = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdown.Separator>
>(function DropdownMenuSeparator({ className, ...rest }, ref) {
  return (
    <RadixDropdown.Separator
      ref={ref}
      className={cn('gs-popover__separator', className)}
      {...rest}
    />
  );
});

export const DropdownMenuLabel = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof RadixDropdown.Label>
>(function DropdownMenuLabel({ className, ...rest }, ref) {
  return (
    <RadixDropdown.Label
      ref={ref}
      className={cn(
        'px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-[var(--color-fg-muted)]',
        className,
      )}
      {...rest}
    />
  );
});
